<template>
  <v-app v-show="isAuthReady">
    <TheHeader />
    <v-main>
      <v-container id="app-container" fluid class="pa-0 pt-16">
        <v-fade-transition hide-on-leave>
          <router-view />
        </v-fade-transition>
      </v-container>
      <Snackbar />
    </v-main>
    <TheFooter />
  </v-app>
</template>

<script>
// @ is an alias to /src
import config from "@/config.js";

import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import Snackbar from "@/components/Snackbar.vue";

import { mapState, mapGetters } from "vuex";

export default {
  components: {
    TheHeader,
    TheFooter,
    Snackbar,
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapState(["isAuthReady"]),
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "API til CVR data - cvr.dev";
    },
  },
  mounted: function () {
    var plausible = document.createElement("script");
    plausible.setAttribute("src", "https://plausible.io/js/plausible.hash.js");
    plausible.setAttribute("data-domain", config.PlausibleDataDomain);
    document.head.appendChild(plausible);
  },
};
</script>

<style>
#app-container {
  padding-top: 24px !important;
}

.v-application a,
.v-application a:visited,
.v-application a:hover,
.v-application a:active,
a,
a:visited,
a:hover,
a:active {
  color: inherit !important;
}
</style>